export default __webpack_public_path__ + "static/hold-7f81a490ba0625c4055afe36217bac46.png";